import React, { useEffect, useState } from 'react'
import './style.scss';
import { setButtonClick, setErrorButton, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setIsShowButtonNot } from '../../store/buttonNotSlice';
import CustomTitle from '../../components/UI/title/CustomTitle';
import TargetContent from './TargetContent';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';

export default function Target({ productivity }) {

    const initialCheckboxState = [[
        {
            id: 0,
            checked: false,
            text: "10–30",
        },
        {
            id: 1,
            checked: false,
            text: "30–70",
        },
        {
            id: 2,
            checked: false,
            text: "70–150",
        },
        {
            id: 3,
            checked: false,
            text: "150–500",
        },
        {
            id: 4,
            checked: false,
            text: "500-1,000",
        },
        {
            id: 5,
            checked: false,
            text: "1,000+",
        }
    ], [
        {
            id: 0,
            checked: false,
            text: "$1-5",
        },
        {
            id: 1,
            checked: false,
            text: "$5-10",
        },
        {
            id: 2,
            checked: false,
            text: "$10-20",
        },
        {
            id: 3,
            checked: false,
            text: "$20-50",
        },
        {
            id: 4,
            checked: false,
            text: "$50-100",
        },
        {
            id: 5,
            checked: false,
            text: "$100+",
        }
    ], [
        {
            id: 0,
            checked: false,
            text: "1–2",
        },
        {
            id: 1,
            checked: false,
            text: "3–4",
        },
        {
            id: 2,
            checked: false,
            text: "5–7",
        },
        {
            id: 3,
            checked: false,
            text: "7–10",
        },
        {
            id: 4,
            checked: false,
            text: "10–15",
        },
        {
            id: 5,
            checked: false,
            text: "15+",
        }
    ], [
        {
            id: 0,
            checked: false,
            text: "3–5%",
        },
        {
            id: 1,
            checked: false,
            text: "5-10%",
        },
        {
            id: 2,
            checked: false,
            text: "10-15%",
        },
        {
            id: 3,
            checked: false,
            text: "15-20%",
        },
        {
            id: 4,
            checked: false,
            text: "20-30%",
        },
        {
            id: 5,
            checked: false,
            text: "Over 30%",
        }
    ]];

    const initialCheckboxStateProductivity = [
        [
            {
                id: 5,
                checked: false,
                text: "",
            },
            {
                id: 0,
                checked: false,
                text: "Up to 10",
            },
            {
                id: 1,
                checked: false,
                text: "Up to 30",
            },
            {
                id: 2,
                checked: false,
                text: "Up to 100",
            },
            {
                id: 3,
                checked: false,
                text: "Up to 300",
            },
            {
                id: 4,
                checked: false,
                text: "More than 300",
            },
        ],
        [
            {
                id: 5,
                checked: false,
                text: "",
            },
            {
                id: 0,
                checked: false,
                text: "Up to $5",
            },
            {
                id: 1,
                checked: false,
                text: "Up to $10",
            },
            {
                id: 2,
                checked: false,
                text: "Up to $20",
            },
            {
                id: 3,
                checked: false,
                text: "Up to $50",
            },
            {
                id: 4,
                checked: false,
                text: "Up to $100",
            },
        ], [
            {
                id: 5,
                checked: false,
                text: "",
            },
            {
                id: 0,
                checked: false,
                text: "Up to 10",
            },

            {
                id: 1,
                checked: false,
                text: "Up to 30",
            },
            {
                id: 2,
                checked: false,
                text: "Up to 50",
            },
            {
                id: 3,
                checked: false,
                text: "Up to 100",
            },
            {
                id: 4,
                checked: false,
                text: "More than 100",
            },
        ], [
            {
                id: 5,
                checked: false,
                text: "",
            },
            {
                id: 0,
                checked: false,
                text: "Up to $5",
            },
            {
                id: 1,
                checked: false,
                text: "Up to $10",
            },
            {
                id: 2,
                checked: false,
                text: "Up to $20",
            },
            {
                id: 3,
                checked: false,
                text: "Up to $50",
            },
            {
                id: 4,
                checked: false,
                text: "Up to $100",
            },
        ], [
            {
                id: 0,
                checked: false,
                text: "1",
            },
            {
                id: 1,
                checked: false,
                text: "Up to 5",
            },
            {
                id: 2,
                checked: false,
                text: "Up to 10",
            },
            {
                id: 3,
                checked: false,
                text: "Up to 50",
            },
            {
                id: 4,
                checked: false,
                text: "Up to 100",
            },
            {
                id: 5,
                checked: false,
                text: "More than 100",
            }
        ],
        [
            {
                id: 0,
                checked: false,
                text: "Up to $50/month",
            },
            {
                id: 1,
                checked: false,
                text: "Up to $100/month",
            },
            {
                id: 2,
                checked: false,
                text: "Up to $200/month",
            },
            {
                id: 3,
                checked: false,
                text: "Up to $500/month",
            },
            {
                id: 4,
                checked: false,
                text: "Up to $1,000/month",
            },
            {
                id: 5,
                checked: false,
                text: "Up to $2,000/month",
            }
        ]];

    const title = [
        'What’s your monthly purchase target?',
        'What’s your CPA target?',
        'What’s your target ROAS?',
        'What’s your target CTR?'
    ]

    const titleProductivity = [
        'How many video ads do you aim to create monthly?',
        'What’s your target cost per video ad?',
        'How many static ads do you aim to create monthly?',
        'What’s your target cost per static ad?',
        'How many campaigns do you aim to launch monthly?',
        'What’s your monthly target on handling ad campaigns?'
    ]
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);


    const [disabled, setDisabled] = useState(true);
    const [checkboxes, setCheckboxes] = useState(productivity ? initialCheckboxStateProductivity[queryParams.get('productivity-goals-id') ?? 0] : initialCheckboxState[queryParams.get('goals') ?? 0]);
    const [error, setError] = useState(false);
    const [value, setValue] = useState('');
    const [targetId, setTargetId] = useState('');
    const dispatch = useDispatch();
    const history = useHistory();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            if (disabled) {
                setError(true);
                dispatch(setErrorButton(true))
                dispatch(setButtonClick(false));
                setTimeout(() => {
                    setError(false);
                    dispatch(setErrorButton(false))
                }, 2000);
                return;
            }
            dispatch(setButtonClick(false));
            queryParams.set('target', value);
            queryParams.set('target-id', targetId);
            trackP1Event('onboarding_ad_target', {
                target_productivity: value,
                goals: queryParams.get('goals-text')
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`,
            });
        }
    }, [buttonClicked, dispatch, disabled]);


    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));

        dispatch(setIsShowButtonNot(false));
    }, []);


    return (
        <div className="page">
            <PageContent>
                <div className="page-content" style={{ paddingRight: '1rem' }}>
                    <CustomTitle
                        style={{ marginBottom: '24rem' }}
                        title={productivity ? titleProductivity[queryParams.get('productivity-goals-id') ? queryParams.get('productivity-goals-id') : 0] : title[queryParams.get('goals') ? queryParams.get('goals') : 0]}
                    />

                    <TargetContent setTargetId={setTargetId} setValue={setValue} checkboxes={checkboxes} setCheckboxes={setCheckboxes} error={error} setDisabled={setDisabled} setError={setError} />

                </div>
            </PageContent>

        </div>
    )
}
